import React from 'react';
import { Col, Row, Text } from 'components';
import { FontAwesome5 } from '@expo/vector-icons';
import { StyleSheet, ScrollView } from 'react-native';
import DeliveryCard, { DeliveryCardData } from './DeliveryCard';

const MSC_BLUE = '#004B8D';
const STEEL_GREY = '#E0E2E5';

interface DeliveryFeedProps {
  deliveries: DeliveryCardData[];
}

const DeliveryFeed: React.FC<DeliveryFeedProps> = ({ deliveries }) => {
  return (
    <Col style={styles.leftPanel}>
      <Row alignItems="center" marginBottom={24}>
        <Col style={styles.sectionIcon}>
          <FontAwesome5 name="route" size={16} color="white" />
        </Col>
        <Text fontSize={20} bold style={{ color: MSC_BLUE, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          LIVE DELIVERY FEED
        </Text>
      </Row>
      <ScrollView showsVerticalScrollIndicator={false}>
        <Col style={styles.deliveryFeed}>
          {deliveries.map((delivery) => (
            <DeliveryCard key={delivery.id} delivery={delivery} />
          ))}
        </Col>
      </ScrollView>
    </Col>
  );
};

const styles = StyleSheet.create({
  leftPanel: {
    flex: 1,
  },
  sectionIcon: {
    width: 32,
    height: 32,
    backgroundColor: MSC_BLUE,
    borderRadius: 8,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 12,
  },
  deliveryFeed: {
    // @ts-ignore
    gap: 16,
  },
});

export default DeliveryFeed;

